import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Form } from "react-formio";
import { Modal } from "react-bootstrap";
import {
  getSurveyPreview,
  getAllQualitySupervisors,
  submitFormData,
} from "../../Utils/adminFunctions";
import { ToastContainer, toast } from "react-toastify";
import ScaleLoader from "react-spinners/ScaleLoader";

let AdminFormView = () => {
  const { surveyID } = useParams();
  const navigate = useNavigate();
  const [surveyName, setSurveyName] = useState("");
  const [formJson, setFormJson] = useState([]);
  const [surveyStatus, setSurveyStatus] = useState([]);
  const [companyLogo, setCompanyLogo] = useState("");
  const [consent, setConsent] = useState();
  const [consentStatementShow, setConsentStatementShow] = useState(false);
  const [participantQualification, setParticipantQualification] =
    useState("no");
  const [listUsers, setListUsers] = useState([]);
  const [desabledBtn, setDesabledBtn] = useState(false);
  const [notifyUsersData, setNotifyUsersData] = useState([]);

  useEffect(() => {
    getSurveyPriview();
  }, []);
  const getSurveyPriview = async () => {
    const response = await getSurveyPreview(surveyID);
    if (response.status === "success") {
      manageQualitySupervisorUser(response.getSiteId, surveyID);
      setNotifyUsersData(response.users);
      setCompanyLogo(response.getCompanyLogo);
      setSurveyName(response.getSurveyName);
      const formJSON = JSON.parse(response.getFormJson)?.map(( item,index )=> {
        if(item.label?.toLowerCase() !== "submit"){
          return ({...item, label:`${index+1}. ${item.label}`})
        } else return item
      })
      setFormJson(formJSON);
      setSurveyStatus(response.getsurveyStatus);
      setConsent(response.getConsent);
      setParticipantQualification(response.getParticipantQualificationStatus);
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  const handleConsentStatementShow = () => {
    setConsentStatementShow(true);
  };
  const handleconsentStatementClose = () => {
    setConsentStatementShow(false);
  };

  const manageQualitySupervisorUser = async (site_id) => {
    let bodyFormData = new FormData();
    bodyFormData.append("site_id", site_id);
    bodyFormData.append("survey_id", surveyID);

    const response = await getAllQualitySupervisors(bodyFormData);
    if (response.status === "success") {
      setListUsers(response.data);
    } else {
      setListUsers([]);
      toast.error(response, { autoClose: 1500 });
    }
  };
  const handleChangeUsers = (e) => {
    const { name, checked } = e.target;
    if (name === "allselect") {
      let tempUser = listUsers.map((user) => {
        return { ...user, isChecked: checked, role: e.target.dataset.role };
      });
      setListUsers(tempUser);
    } else {
      let tempUser = listUsers.map((user) => {
        return user.user_id == name
          ? { ...user, isChecked: checked, role: e.target.dataset.role }
          : user;
      });
      setListUsers(tempUser);
    }
  };
  const handlersendrequesttousers = async () => {
    setDesabledBtn(true);
    const checkedUsers = [];
    const roles = [];
    for (let i = 0; i < listUsers.length; i++) {
      if (listUsers[i].isChecked === true) {
        checkedUsers.push(parseInt(listUsers[i].user_id));
        roles.push(listUsers[i].role);
      }
    }
    if (checkedUsers.length != 2) {
      setDesabledBtn(false);
      toast.warning("Please select only two users", {
        autoClose: 1500,
      });
      return false;
    } else if (
      (roles.includes("Primary User") || roles.includes("Secondary User")) &&
      roles.includes("Quality Supervisor")
    ) {
      const bodyFormData = new FormData();
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("users", checkedUsers);
      bodyFormData.append("action", "draft_released");
      const response = await submitFormData("sentsurveyrequest", bodyFormData);
      if (response.status == "success") {
        getSurveyPriview();
        toast.success(response.message, { autoClose: 1500 });
        document.querySelector(".close_popup").click();
        //navigate("/AdminSurveyDetails/" + surveyID);
        navigate(`/AdminSurveyDetails/${surveyID}`);
        setDesabledBtn(false);
      } else {
        setDesabledBtn(false);
        toast.error(response.message, { autoClose: 1500 });
      }
    } else {
      toast.warning("Please Choose One Quality Supervisor", {
        autoClose: 1500,
      });
      setDesabledBtn(false);
      return false;
    }
  };

  const handlersendrequestforsurveydraftreview = async () => {
    setDesabledBtn(true);
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("users", notifyUsersData);
    bodyFormData.append("action", "draft_released");
    const response = await submitFormData("sentsurveyrequest", bodyFormData);
    if (response.status === "success") {
      toast.success(response.message, { autoClose: 1500 });
      setTimeout(navigate("/AdminSurveyDetails/" + surveyID), 5000);
    } else {
      setDesabledBtn(false);
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  return (
    <div>
      {desabledBtn&&(
        <div style={{
          zIndex:100000,
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          position: "fixed",
         inset:0,
          backgroundColor: 'rgba(86, 86, 86, 0.8)'
        }}>
        <ScaleLoader
  color="#F58634"
  height={100}
  margin={5}
  radius={8}
  width={20}
/>
        </div>
      )}
      
      <Modal
        show={consentStatementShow}
        onHide={handleconsentStatementClose}
        animation={false}
        className="cmpopup"
      >
        <Modal.Header className="contentBopup">
          <h5>
            <b>Consent</b>
          </h5>
        </Modal.Header>
        <Modal.Body>
          <p>{consent}</p>
        </Modal.Body>
      </Modal> 
      <div className="modal fade" id="modal-default" arial-modal="true">
        <input type="hidden" id="deleteListsite" value=""></input>
        <div className="modal-dialog" style={{maxWidth:"600px"}}>
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Confirm </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <table
                id="userlist1"
                className="table table-bordered table-striped"
              
              >
                <thead>
                  <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                  </tr>
                </thead>
                <tbody>
                  {listUsers.length > 0 ? (
                    listUsers.map((item, i) => (
                      <tr key={++i}>
                        <td>
                          <input
                            type="checkbox"
                            data-role={item.role}
                            name={item.user_id}
                            checked={item?.isChecked || false}
                            disabled={item?.disabled || false}
                            onChange={handleChangeUsers}
                          />
                        </td>
                        <td>{item.first_name} {item.last_name}</td>
                        <td>{item?.email}</td>
                        <td>{item.role}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center">
                        Result not found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark close_popup"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm custom-btn-primary"
                onClick={() => {
                  handlersendrequesttousers();
                }}
                disabled={desabledBtn}
              >
                
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid custom-container-fluid-background-survey">
        <div className="survey-header">
          <div className="row">
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-box rounded-0">
                <center>
                  <img
                    src={companyLogo}
                    alt="image not available"
                    height={35}
                  ></img>
                </center>
                <br></br>
                <center>
                  {" "}
                  <h6>
                    <b>{surveyName}</b>
                  </h6>
                </center>
              </div>
            </div>
          </div>

          <div className="offset-md-1 col-md-10 offset-md-1">
            <div className="action-button-view-page form-view-action">
              {participantQualification === "yes" && (
                <>
                  <Link
                    to={"/AdminParticipantQualificationView/" + surveyID}
                    className="btn btn-sm custom-btn-primary"
                  >
                    Participant Qualification
                  </Link>{" "}
                </>
              )}
              {consent}
              {/* <Link
                to="#"
                onClick={() => {
                  handleConsentStatementShow();
                }}
                className="btn btn-sm custom-btn-primary"
              >
                Consent Statement
              </Link> */}
              <Link
                to={"/AdminSurveyDetails/" + surveyID}
                className="btn btn-sm custom-btn-primary pull-right"
              >
                <i className="fa fa-arrow-left"></i> Back
              </Link>
            </div>
          </div>

          <div className="row form-box-top-margin">
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-box disabled_form_submit">
                <Form
                  src={{
                    display: "form",
                    components: formJson,
                  }}
                  options={{ readOnly: false }}
                />
                <button
                  className="btn btn-md custom-btn-primary custom_disabled_btn"
                  disabled
                >
                  Submit
                </button>
              </div>
              <div className="col-md-12 p-2">
                <center>
                  {surveyStatus == "draft_released_to_primary_user" && (
                    <>
                      <button
                        className="btn btn-sm custom-btn-primary"
                        data-toggle="modal"
                        data-target="#modal-default"
                      >
                        Release Draft
                      </button>
                    </>
                  )}
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminFormView;
